export default {
  'component.marketingandsales.title': 'Markedsføring & salg',
  'component.marketingandsales.card1.seefinnad': 'See finn annonse',
  'component.marketingandsales.card2.digitalsalesassignment': 'Digital salgsoppgave',
  'component.marketingandsales.card3.marketingmaterials': 'Markedsmateriell',
  'component.marketingandsales.card4.display': 'Visning',
  'component.marketingandsales.card5.bids': 'Bud',
  'component.marketing.title': 'Markedsføring',
};
